import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { BrowserRouter} from "react-router-dom";
 

import {StoreProvider} from "./store";

ReactDOM.render(
<BrowserRouter>
    <StoreProvider>
    <App /> 
    </StoreProvider>
</BrowserRouter>, 
document.getElementById('root'));

 
